/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { CurativeAction } from '../../../model/CurativeAction';
import { BaseController } from '../../BaseController';

class CurativeActionViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, curativeActionService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, $mdDialog, data) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.curativeActionService = curativeActionService;
        this.$mdDialog = $mdDialog;
        this.actionRequestId = data.actionRequestId;
        this.parts = data.parts;
        this.$log.debug('Controller \'CurativeActionViewController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn('CurativeActionViewController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            super.$onInit();

            this.curativeAction = new CurativeAction(this.actionRequestId);
            this.formDisabled = false;
            this.initialized = true;
        }
    }

    applyChangedParts() {
        this.curativeAction.changedParts = [];
        this.selectedPartIds.forEach(selectedPartId => this.curativeAction.changedParts.push({
            equipmentTemplatePartId: selectedPartId
        }));
    }

    /**
     * Converts this form data to valid DTO (form multiparts).
     *
     * @return {Object} Form multiparts, indexed by name.
     */
    convertToDto() {
        const formData = {
            curativeAction: new Blob([angular.toJson(this.curativeAction)], {type: 'application/json'}),
            attachments: this.attachments
        };
        return formData;
    }

    save() {
        if (!this.attachments || this.areAttachmentsValid(this.attachments)) {
            this.formDisabled = true;
            this.handleRestServiceCall(
                this.curativeActionService.createEntityWithUpload(
                    { actionRequestId: this.curativeAction.actionRequestId },
                    this.convertToDto()
                ),
                () => {
                    this.notificationService.pushMessage('ui.curativeaction.created',
                        this.configuration.NOTIFIER_LEVEL_INFO);
                    this.$mdDialog.hide(true);
                }
            ).finally(() => {
                this.formDisabled = false;
            });
        }
    }

    cancel() {
        this.$mdDialog.hide(false);
    }
}

export { CurativeActionViewController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/component/CurativeActionView.js